<template>
  <div class="inner-box">
    <el-form size="small">
      <div class="content-name">
        <h2 class="dp-ib">센터관리</h2>
        <el-form-item label-width="0px" style="float: right;">
          <el-button type="success" icon="el-icon-document-checked" @click="tempDownload">
            엑셀
          </el-button>
          <el-button type="primary" icon="el-icon-search" @click="goOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
        </el-form-item>
      </div>
    </el-form>
    <!-- 검색조건 영역 -->
    <div class="search-form">
      <el-form size="mini" label-width="80px">
        <el-row style="margin-bottom: 0px;">
          <el-col :span="4">
            <el-form-item label="센터구분">
              <el-select v-model="form.asAgentType">
                <el-option value=''  label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['asAgentType']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="지역">
              <el-select v-model="form.area">
                <el-option value='' label="전체">==전체==</el-option>
                <el-option
                    v-for="item in combos['areaAgent']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="센터명">
              <el-input type="text" v-model="form.asAgentNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="계약상태">
              <el-select v-model="form.contractStatus">
                <el-option value='' label="전체">==전체==</el-option>
                <el-option
                      v-for="item in combos['contractStatus']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="대표자명">
              <el-input type="text" v-model="form.keyManNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="상호명">
              <el-input type="text" v-model="form.asAgentFullNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="기사명">
              <el-input type="text" v-model="form.userNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="기사ID">
              <el-input type="text" v-model="form.userCd"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 테이블 -->
    <!-- GRID -->
    <div class="inner-box">
      <div class="table-b">
      <div class="grid-wrap">
        <ag-grid-vue ref="grid"
                     style="padding-top: 40px; width: 100%; height: calc(48vh);"
                     class="ag-theme-alpine"
                     :enableRangeSelection="true"
                     :columnDefs="columnDefs"
                     :gridOptions="gridOptions"
                     :rowData="data"
                     :defaultColDef="defaultColDef"
                     :statusBar="statusBar"
                     @grid-ready="onReadyMain"
                     @cell-clicked="onCellClickedMain"
        />
        <ag-grid-vue ref="gridTemp"
                     class="ag-theme-alpine"
                     rowSelection="single"
                     :columnDefs="columnDefsTemp"
                     :gridOptions="gridOptionsTemp"
                     :rowData="tempData"
                     :defaultColDef="defaultColDefTemp"
                     :statusBar="statusBar"
                     v-show="false"
        />
      </div>
      </div>
      <div class="table-header">
        <el-form style="display: grid; float: right;" size="small">
          <el-form-item label-width="0px">
            <el-button type="info" icon="fas fa-key" v-if="this.viewer == 'AgentInfo'" @click="pwdChange"> 비밀번호변경</el-button>
            <el-button type="info" icon="el-icon-close" v-if="this.viewer == 'AgentInfo'" @click="Acancel">취소</el-button>
            <el-button type="info" icon="el-icon-close" v-if="this.viewer == 'DefaultInfo'" @click="Dcancel">취소</el-button>
            <el-button type="danger" icon="el-icon-delete" v-if="this.viewer != 'Timetable'" @click="deleteRow">삭제</el-button>
            <el-button type="primary" icon="el-icon-document-add" @click="save">저장</el-button>
          </el-form-item>
        </el-form>
      </div>
      <tabs :tab="tab" :active-btn="active" @changeTab="changeTab"/>
      <component ref="cmpTab" v-bind:is="viewer" :custParam="custParam" :selectId="selectId"/>

    </div>
    <!-- GRID -->

  </div>

</template>

<script>
import _ from 'lodash';
import common from '@/mixin/common';
import mixinSlip from '@/mixin/slip';
import DefaultInfo from '@/components/InfoManage/AgentInfo/DefaultInfo.vue';
import AgentInfo from '@/components/InfoManage/AgentInfo/AgentInfo.vue';
import Timetable from '@/components/InfoManage/AgentInfo/Timetable.vue';
import tabs from "@/components/AS/Tabs";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import PwdChange from "@/components/PwdChange";


export default {
  name:'AgentManager',
  mixins: [common, mixinSlip],
  components: {
    DefaultInfo,
    AgentInfo,
    Timetable,
    tabs
  },


  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      parentNm: "",
      viewer: 'DefaultInfo',
      rowData: [],
      rowD: [],
      tab:[
        {tabId: 'DefaultInfo', tabName:'기본정보', tabCss:"btn btn-primary", tabNo:'0'},
        {tabId: 'AgentInfo', tabName:'기사정보', tabCss:"btn btn-outline-primary", tabNo:'1'},
        {tabId: 'Timetable', tabName:'근무시간표', tabCss:"btn btn-outline-primary", tabNo:'2'},
      ],
      active: true,
      custParam:{},
      form: {
        userId: "",
        userCd: "",
        groupUid: "",
        positionCd: "",
        userNm: "",
        carNo: "",
        enterDt: "",
        weekMorning: "",
        weekAfterNoon: "",
        weekEndMorning: "",
        weekEndAfterNoon: "",
        addr1:"",
        addr2:"",
        area:"",
        asAgentFullNm:"",
        asAgentId:"",
        asAgentNm:"",
        asAgentType:"",
        businessNo:"",
        businessStatus:"",
        businessType:"",
        companyId:"",
        contractEndDt:"",
        contractStartDt:"",
        contractStatus:"",
        createDt:"",
        creatorId:"",
        creatorNm:"",
        deleteYn:"",
        description:"",
        email:"",
        friAfterNoonYn:"",
        friMorningYn:"",
        guaranteeInsurance:"",
        hpNo:"",
        keyManNm:"",
        monAfterNoonYn:"",
        monMorningYn:"",
        satAfterNoonYn:"",
        satMorningYn:"",
        sunAfterNoonYn:"",
        sunMorningYn:"",
        telNo:"",
        territory:"",
        thuAfterNoonYn:"",
        thuMorningYn:"",
        tueAfterNoonYn:"",
        tueMorningYn:"",
        updateDt:"",
        updatorId:"",
        updatorNm:"",
        wedAfterNoonYn:"",
        wedMorningYn:"",
        zipCd:"",
        subArea:"",
        subAsAgentId:"",
      },
      defForm: {
        userId: "",
        userCd: "",
        groupUid: "",
        positionCd: "",
        userNm: "",
        carNo: "",
        enterDt: "",
        weekMorning: "",
        weekAfterNoon: "",
        weekEndMorning: "",
        weekEndAfterNoon: "",
        addr1:"",
        addr2:"",
        area:"",
        asAgentFullNm:"",
        asAgentId:"",
        asAgentNm:"",
        asAgentType:"",
        businessNo:"",
        businessStatus:"",
        businessType:"",
        companyId:"",
        contractEndDt:"",
        contractStartDt:"",
        contractStatus:"",
        createDt:"",
        creatorId:"",
        creatorNm:"",
        deleteYn:"",
        description:"",
        email:"",
        friAfterNoonYn:"",
        friMorningYn:"",
        guaranteeInsurance:"",
        hpNo:"",
        keyManNm:"",
        monAfterNoonYn:"",
        monMorningYn:"",
        satAfterNoonYn:"",
        satMorningYn:"",
        sunAfterNoonYn:"",
        sunMorningYn:"",
        telNo:"",
        territory:"",
        thuAfterNoonYn:"",
        thuMorningYn:"",
        tueAfterNoonYn:"",
        tueMorningYn:"",
        updateDt:"",
        updatorId:"",
        updatorNm:"",
        wedAfterNoonYn:"",
        wedMorningYn:"",
        zipCd:"",
        subArea:"",
        subAsAgentId:"",
      },
      combos: {
        'asAgentType' : [],           //센터구분
        'areaAgent' : [],             //지역구분
        'areaAgent2' : [],             //지역구분
        'contractStatus' : [],        //계약상태
      },
      data: [],
      tempData: [],
      subData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      gridOptionsTemp: {},
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefTemp: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      groupDetail: [],
      gridApi: null,
      gridApiTemp: null,
      columnApi: null,
      columnDefs: [],
      columnDefsTemp: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsSub: [],
      frameworkComponents: null,
      autoGroupColumnDef: null,
      rowModelType: null,
      isServerSideGroupOpenByDefault: null,
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      selectId : "",
    };
  },
  methods: {
    changeTab(params) {
      // const voRow = this.gridApi.getSelectedRows() //선택된 Row
      const voRow = this.rowData;

      if(voRow.length == 0) {
        this.$swal({type: 'warning', text: '센터를 선택해주세요.'});
        this.tab[0].tabCss = 'btn btn-primary';
        this.tab[1].tabCss = 'btn btn-outline-primary';
        this.tab[2].tabCss = 'btn btn-outline-primary';
        return false;
      }
      this.viewer = params.tabId;

      if(this.viewer == 'AgentInfo'){
        this.agentInfo(voRow);
      }else if(this.viewer == 'Timetable'){
        this.defaultInfo(voRow);
      }else{
        this.defaultInfo(voRow);
      }

    },
    defaultInfo(row){

      // this.$store.commit('loading')
      this.$http
          .post("/api/asAgentMng/detail/default", {
            companyId: this.$store.state.loginInfo.compCd,
            asAgentId: row.asAgentId,
            userId : 0,
            useYn : 'Y',
            processTime: ""
          })
          .then(response => {
            this.custParam = response.data[0];
            this.selectId = row.asAgentId;
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    agentInfo(row){

      if(this.isEmpty(row.asAgentId) == '' ) row.asAgentId = this.selectId

      // this.$store.commit('loading')
      this.$http
          .post("/api/asAgentMng/detail/agent2", {
            companyId: this.$store.state.loginInfo.compCd,
            asAgentId: row.asAgentId,
            userId : 0,
            useYn : 'Y',
            processTime: ""
          })
          .then(response => {
            this.custParam = response.data;
            this.selectId = row.asAgentId;
            // this.cancel();
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    timeTableInfo(row){
      this.tapName = "time";
    },
    //메인그리드 Ready
    onReadyMain(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();

      this.init();

      this.goOpen();

    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;

      this.gridApiSub.sizeColumnsToFit();
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this


      this.columnDefs = [
        {headerName:'센터ID', field:'asAgentCd', width:80, editable:false},
        {headerName:'센터구분', field:'asAgentType', width:50, editable:false,
          valueFormatter: function(params) {
            return vm.chkType(params.value);
          }
        },
        {headerName:'센터명', field:'asAgentNm', width:50, editable:false},
        {headerName:'사업장명', field:'asAgentFullNm', width:50, editable:false},
        {headerName:'대표자명', field:'keyManNm', width:50, editable:false},
        {headerName:'사업장주소', field:'addr', width:50, editable:false,
          valueFormatter: function(params) {
            return params.data.addr1 + ' ' + params.data.addr2
          }
        },
        {headerName:'업종/업태', field:'businessType', width:50, editable:false},
        {headerName:'타사운영현황', field:'description', width:50, editable:false},
        {headerName:'', field:'catId', hide : true},];

      this.columnDefsTemp = [
        {headerName:'센터ID', field:'asAgentCd', width:80, editable:false},
        {headerName:'센터구분', field:'asAgentTypeStr', width:50, editable:false},
        {headerName:'센터명', field:'asAgentNm', width:50, editable:false},
        {headerName:'사업장명', field:'asAgentFullNm', width:50, editable:false},
        {headerName:'사업자번호', field:'businessNo', width:50, editable:false},
        {headerName:'사업자구분', field:'businessType', width:50, editable:false},
        {headerName:'대표자명', field:'keyManNm', width:50, editable:false},
        {headerName:'사업장주소', field:'addr', width:50, editable:false},
        {headerName:'업종', field:'territory', width:50, editable:false},
        {headerName:'업태', field:'businessStatus', width:50, editable:false},
        {headerName:'지역', field:'areaStr', width:50, editable:false},
        {headerName:'대표번호', field:'telNo', width:50, editable:false},
        {headerName:'핸드폰', field:'hpNo', width:50, editable:false},
        {headerName:'이메일', field:'email', width:50, editable:false},
        {headerName:'타사운영현황', field:'description', width:50, editable:false},
        {headerName:'이행보증보험', field:'guaranteeInsurance', width:50, editable:false},
        {headerName:'계약기간', field:'contractDt', width:50, editable:false},
        {headerName:'', field:'catId', hide : true},];
    },
    //Main 그리드 SelctionChange 발생
    onCellClickedMain(params) {
      const voRow = params.data //선택된 Row
      this.rowData = params.data;
      this.catDetail = this.defForm;
      this.selectId = voRow.asAgentId;

      if(this.viewer == 'AgentInfo'){
        this.agentInfo(voRow);
      }else if(this.viewer == 'Timetable'){
        this.defaultInfo(voRow);
      }else{
        this.defaultInfo(voRow);
      }
    },
    tempDownload(){
      this.gridOptionsTemp.api.exportDataAsExcel({fileName: '센터리스트'});
    },
    isEmpty(value){
      if( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
        return ""
      }else{
        return value
      }
    },
    goOpen() {
        this.$store.commit('loading')
        this.$http
            .post("/api/asAgentMng/list", {
              companyId: this.$store.state.loginInfo.compCd,
              asAgentType : this.form.asAgentType,
              asAgentNm : this.form.asAgentNm,
              asAgentFullNm : this.form.asAgentFullNm,
              keyManNm : this.form.keyManNm,
              userNm : this.form.userNm,
              userCd : this.form.userCd,
              asAgentCd : this.form.asAgentCd,
              catId : this.form.area == '' ? 0 : this.form.area,
              contractStatus : this.form.contractStatus,
              sortType : true,
              page : 1,
              totalPage : 9999,
              totalCount : 9999,
              curPage : 1,
              processTime : ""
            })
            .then(response => {
              this.data = response.data;
              this.tempData = response.data;
              this.tempData.forEach(x=>{
                x.addr = x.addr1 + ' ' + x.addr2 ;
                x.contractDt = this.getDateFormat(x.contractStartDt) + ' ~ ' + this.getDateFormat(x.contractEndDt);
                x.asAgentTypeStr = this.chkType(x.asAgentType);
                x.areaStr = this.chkArea(x.area);
              });

              this.cancel();
            }).finally(() => {
          this.$store.commit('finish')
        });

    },
    goAgnetList(){

    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
    save() {
        const agentInfo = JSON.parse(JSON.stringify(this.$refs.cmpTab.form));
        const voRow = this.rowData;

      if(this.viewer == 'AgentInfo'){

        if(agentInfo.userCd == "") {
          this.$swal({type: 'warning', text: 'ID를 입력해 주십시오.'});
          return false;
        }else if(agentInfo.groupUid == ""){
          this.$swal({type: 'warning', text: '그룹구분을 입력해 주십시오.'});
          return false;
        }else if(agentInfo.positionCd == ""){
          this.$swal({type: 'warning', text: '직급을 입력해 주십시오.'});
          return false;
        }else if(agentInfo.userNm == ""){
          this.$swal({type: 'warning', text: '성명을 입력해 주십시오.'});
          return false;
        }else if(agentInfo.enterDt == ""){
          this.$swal({type: 'warning', text: '입사일자를 입력해 주십시오.'});
          return false;
        }else if(agentInfo.hpNo == ""){
          this.$swal({type: 'warning', text: '휴대폰번호를 입력해 주십시오.'});
          return false;
        }else if(agentInfo.weekMorning == ""){
          this.$swal({type: 'warning', text: '평일 오전 근무여부를 입력해 주십시오.'});
          return false;
        }else if(agentInfo.weekAfterNoon == ""){
          this.$swal({type: 'warning', text: '평일 오후 근무여부를 입력해 주십시오.'});
          return false;
        }else if(agentInfo.weekEndMorning == ""){
          this.$swal({type: 'warning', text: '토요일 오전 근무여부를 입력해 주십시오.'});
          return false;
        }else if(agentInfo.weekEndAfterNoon == ""){
          this.$swal({type: 'warning', text: '토요일 오후 근무여부를 입력해 주십시오.'});
          return false;
        }


        // 비어있다면 생성 , 비어있지 않다면 수정
        if(agentInfo.userId == ""){



          //저장 시작
          this.$http
              .put('/api/asAgentMng/detail/agent/save',{
                companyId: this.$store.state.loginInfo.compCd,
                userCd: agentInfo.userCd,
                asAgentId: this.selectId,
                groupUid: agentInfo.groupUid,
                positionCd: agentInfo.positionCd,
                userNm: agentInfo.userNm,
                carNo: agentInfo.carNo,
                enterDt: agentInfo.enterDt,
                area: agentInfo.area,
                hpNo: agentInfo.hpNo,
                weekMorning: agentInfo.weekMorning,
                weekAfterNoon: agentInfo.weekAfterNoon,
                weekEndMorning: agentInfo.weekEndMorning,
                weekEndAfterNoon: agentInfo.weekEndAfterNoon,
                creatorId: this.$store.state.loginInfo.id,
                userId: 0,
                processTime: "",
              })
              .then(response => {
                this.$swal({ type: 'success', text: '저장되었습니다.' });
                this.Acancel();
                this.agentInfo(this.selectId);
              })
              .catch(e => {
                this.$swal({type: 'error', text: e.response.data.message});
                return e;
              });
        }else{
          //수정 시작
          this.$http
              .put('/api/asAgentMng/detail/agent/update',{
                companyId: this.$store.state.loginInfo.compCd,
                userId: agentInfo.userId,
                userCd: agentInfo.userCd,
                asAgentId: agentInfo.asAgentId,
                groupUid: agentInfo.groupUid,
                positionCd: agentInfo.positionCd,
                userNm: agentInfo.userNm,
                carNo: agentInfo.carNo,
                enterDt: agentInfo.enterDt,
                area: agentInfo.area,
                hpNo: agentInfo.hpNo,
                weekMorning: agentInfo.weekMorning,
                weekAfterNoon: agentInfo.weekAfterNoon,
                weekEndMorning: agentInfo.weekEndMorning,
                weekEndAfterNoon: agentInfo.weekEndAfterNoon,
                updatorId: this.$store.state.loginInfo.id,
                processTime: ""
              })
              .then(response => {
                this.$swal({ type: 'success', text: '저장되었습니다.' });
                this.Acancel();
                this.agentInfo(this.selectId);
              })
              .catch(e => {
                this.$swal({type: 'error', text: e.response.data.message});
                return e;
              });

        }

      }else if(this.viewer == 'Timetable'){

        //수정 시작
        this.$http
            .put('/api/asAgentMng/detail/schedule/update',{
              companyId: this.$store.state.loginInfo.compCd,
              asAgentId: this.selectId,
              monMorningYn: agentInfo.monMorningYn,
              monAfterNoonYn: agentInfo.monAfterNoonYn,
              tueMorningYn: agentInfo.tueMorningYn,
              tueAfterNoonYn: agentInfo.tueAfterNoonYn,
              wedMorningYn: agentInfo.wedMorningYn,
              wedAfterNoonYn: agentInfo.wedAfterNoonYn,
              thuMorningYn: agentInfo.thuMorningYn,
              thuAfterNoonYn: agentInfo.thuAfterNoonYn,
              friMorningYn: agentInfo.friMorningYn,
              friAfterNoonYn: agentInfo.friAfterNoonYn,
              satMorningYn: agentInfo.satMorningYn,
              satAfterNoonYn: agentInfo.satAfterNoonYn,
              sunMorningYn: agentInfo.sunMorningYn,
              sunAfterNoonYn: agentInfo.sunAfterNoonYn,
              updatorId: this.$store.state.loginInfo.id,
              processTime: ""
            })
            .then(response => {
              this.$swal({ type: 'success', text: '저장되었습니다.' });
              this.timeTableInfo(voRow);
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            });

    }else{ // DefaultInfo


        // 비어있다면 생성 , 비어있지 않다면 수정
        if(agentInfo.asAgentId == ""){

          //상세코드 확인
          if(agentInfo.asAgentCd == "") {
            this.$swal({type: 'warning', text: '센터ID를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.asAgentNm == ""){
            this.$swal({type: 'warning', text: '센터명을 입력해 주십시오.'});
            return false;
          }else if(agentInfo.keyManNm == ""){
            this.$swal({type: 'warning', text: '대표자명을 입력해 주십시오.'});
            return false;
          }else if(agentInfo.zipCd == ""){
            this.$swal({type: 'warning', text: '우편번호를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.addr1 == ""){
            this.$swal({type: 'warning', text: '상세주소를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.addr2 == ""){
            this.$swal({type: 'warning', text: '상세주소를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.businessType == ""){
            this.$swal({type: 'warning', text: '사업자구분을 입력해 주십시오.'});
            return false;
          }else if(agentInfo.businessNo == ""){
            this.$swal({type: 'warning', text: '사업자번호를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.territory == ""){
            this.$swal({type: 'warning', text: '업종을 입력해 주십시오.'});
            return false;
          }else if(agentInfo.businessStatus == ""){
            this.$swal({type: 'warning', text: '업태를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.telNo == ""){
            this.$swal({type: 'warning', text: '대표전화번호를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.hpNo == ""){
            this.$swal({type: 'warning', text: '핸드폰번호를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.email == ""){
            this.$swal({type: 'warning', text: '이메일주소를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.description == ""){
            this.$swal({type: 'warning', text: '담당지역을 입력해 주십시오.'});
            return false;
          }else if(agentInfo.contractStartDt == ""){
            this.$swal({type: 'warning', text: '계약기간을 입력해 주십시오.'});
            return false;
          }else if(agentInfo.contractEndDt == ""){
            this.$swal({type: 'warning', text: '계약기간을 입력해 주십시오.'});
            return false;
          }

          //저장 시작

          // alert("asAgentId : " + agentInfo.asAgentId);
          // alert("addr1 : " + agentInfo.addr1);
          // alert("addr2 : " + agentInfo.addr2);
          // alert("area : " + agentInfo.area);

          this.$http
              .put('/api/asAgentMng/save',{
                companyId: this.$store.state.loginInfo.compCd,
                asAgentId: 0,
                asAgentCd: agentInfo.asAgentCd,
                asAgentType: agentInfo.asAgentType,
                asAgentNm: agentInfo.asAgentNm,
                asAgentFullNm: agentInfo.asAgentFullNm,
                businessNo: agentInfo.businessNo,
                keyManNm: agentInfo.keyManNm,
                zipCd: agentInfo.zipCd,
                addr1: agentInfo.addr1,
                addr2: agentInfo.addr2,
                hpNo: agentInfo.hpNo,
                email: agentInfo.email,
                telNo: agentInfo.telNo,
                territory: agentInfo.territory,
                businessStatus: agentInfo.businessStatus,
                businessType: agentInfo.businessType,
                description: agentInfo.description,
                area: agentInfo.area,
                guaranteeInsurance: agentInfo.guaranteeInsurance,
                contractStartDt: agentInfo.contractStartDt,
                contractEndDt: agentInfo.contractEndDt,
                contractStatus: agentInfo.contractStatus,
                creatorId: this.$store.state.loginInfo.id,
                subAsAgentId : this.isEmpty(agentInfo.subAsAgentId) == "" ? 0 : agentInfo.subAsAgentId,
                processTime: ""
              })
              .then(response => {
                this.$swal({ type: 'success', text: '저장되었습니다.' });
                this.goOpen();
              })
              .catch(({ message }) => {
                if (message === "Request failed with status code 500") {
                  this.$swal({ type: "error", text: "오류가 발생했습니다." });
                }
              });
        }else{


          //상세코드 확인
          if(agentInfo.asAgentCd == "") {
            this.$swal({type: 'warning', text: '센터ID를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.asAgentNm == ""){
            this.$swal({type: 'warning', text: '센터명을 입력해 주십시오.'});
            return false;
          }else if(agentInfo.keyManNm == ""){
            this.$swal({type: 'warning', text: '대표자명을 입력해 주십시오.'});
            return false;
          }else if(agentInfo.zipCd == ""){
            this.$swal({type: 'warning', text: '우편번호를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.addr1 == ""){
            this.$swal({type: 'warning', text: '상세주소를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.addr2 == ""){
            this.$swal({type: 'warning', text: '상세주소를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.businessType == ""){
            this.$swal({type: 'warning', text: '사업자구분을 입력해 주십시오.'});
            return false;
          }else if(agentInfo.businessNo == ""){
            this.$swal({type: 'warning', text: '사업자번호를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.territory == ""){
            this.$swal({type: 'warning', text: '업종을 입력해 주십시오.'});
            return false;
          }else if(agentInfo.businessStatus == ""){
            this.$swal({type: 'warning', text: '업태를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.telNo == ""){
            this.$swal({type: 'warning', text: '대표전화번호를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.hpNo == ""){
            this.$swal({type: 'warning', text: '핸드폰번호를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.email == ""){
            this.$swal({type: 'warning', text: '이메일주소를 입력해 주십시오.'});
            return false;
          }else if(agentInfo.description == ""){
            this.$swal({type: 'warning', text: '담당지역을 입력해 주십시오.'});
            return false;
          }else if(agentInfo.contractStartDt == ""){
            this.$swal({type: 'warning', text: '계약기간을 입력해 주십시오.'});
            return false;
          }else if(agentInfo.contractEndDt == ""){
            this.$swal({type: 'warning', text: '계약기간을 입력해 주십시오.'});
            return false;
          }

          //수정 시작
          this.$http
              .put('/api/asAgentMng/update',{
                companyId: this.$store.state.loginInfo.compCd,
                asAgentId: agentInfo.asAgentId,
                asAgentCd: agentInfo.asAgentCd,
                asAgentType: agentInfo.asAgentType,
                asAgentNm: agentInfo.asAgentNm,
                asAgentFullNm: agentInfo.asAgentFullNm,
                businessNo: agentInfo.businessNo,
                keyManNm: agentInfo.keyManNm,
                zipCd: agentInfo.zipCd,
                addr1: agentInfo.addr1,
                addr2: agentInfo.addr2,
                hpNo: agentInfo.hpNo,
                email: agentInfo.email,
                telNo: agentInfo.telNo,
                territory: agentInfo.territory,
                businessStatus: agentInfo.businessStatus,
                businessType: agentInfo.businessType,
                description: agentInfo.description,
                area: agentInfo.area,
                guaranteeInsurance: agentInfo.guaranteeInsurance,
                contractStartDt: agentInfo.contractStartDt,
                contractEndDt: agentInfo.contractEndDt,
                contractStatus: agentInfo.contractStatus,
                updatorId: this.$store.state.loginInfo.id,
                subAsAgentId : this.isEmpty(agentInfo.subAsAgentId) == "" ? 0 : agentInfo.subAsAgentId,
                processTime: "",
              })
              .then(response => {
                if(agentInfo.contractStatus === "N"){

                  this.$swal({
                    type: 'info',
                    text: `센터를 해지하는 경우, 관할지역을 다른 센터로 변경하시기 바랍니다.`,
                    showCancelButton: true,
                    confirmButtonText: '예',
                    cancelButtonText: '아니오',
                  }).then((result) => {
                    if (result.value) {

                      this.$store.commit('loading')

                      this.$router.push({
                        path: '/agentZoneManager',
                        query : { asAgentId : agentInfo.asAgentId, area : agentInfo.area}
                      })
                    }
                  });

                }else{
                  this.$swal({ type: 'success', text: '수정되었습니다.' });
                  this.goOpen()
                }
              })
              .catch(({ message }) => {
                if (message === "Request failed with status code 500") {
                  this.$swal({ type: "error", text: "오류가 발생했습니다." });
                }
              });
        }

      }




    },
    deleteRow() {

      const agentInfo = JSON.parse(JSON.stringify(this.$refs.cmpTab.form));

      if(this.viewer == 'AgentInfo'){

        const grid = this.$refs.cmpTab.$refs.agentGrid;

        const chkDatas = grid.rowData.filter((x,i) => {
          return x.regYn === "1"
        })


        if(agentInfo.userId == ""){
          this.$swal({ type: 'warning', text: '삭제 할 사용자를 선택해주세요.' });
          return false;
        }

        let submitList = [];
        for(var i=0; chkDatas.length > i; i++){
          submitList.push({
            companyId: this.$store.state.loginInfo.compCd,
            userId: chkDatas[i].userId,
            userCd: chkDatas[i].userCd,
            updatorId: this.$store.state.loginInfo.id,
            processTime: ""
          });
        }


        this.$http.put('/api/asAgentMng/detail/agent/delete',submitList)
          .then(response => {
            this.$swal({ type: 'success', text: '삭제되었습니다.' });
            this.Acancel();
            this.agentInfo(this.selectId);
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });
      }else{
        if(agentInfo.asAgentId == "") {
          this.$swal({ type: 'warning', text: '삭제 할 우편번호를 선택해주세요.' });
          return false;
        }

        this.$http
          .put('/api/asAgentMng/delete',{
            companyId: this.$store.state.loginInfo.compCd,
            asAgentId: agentInfo.asAgentId,
            updatorId: this.$store.state.loginInfo.id,
            processTime: ""
          })
          .then(response => {
            this.$swal({ type: 'success', text: '삭제되었습니다.' });
            this.goOpen();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });
      }
    },
    chkType(value) {
      let val = '';

      this.combos['asAgentType'].forEach(x =>{
        if(value == x.key){
          val =  x.value
        }
      })

      return val == '' ? value : val;
    },
    chkArea(value) {
      let val = '';

      this.combos['areaAgent2'].forEach(x =>{
        if(value == x.key){
          val =  x.value;
        }
      })

      return val == '' ? value : val;
    },
    Dcancel(){
      // form 초기화
      this.$refs.cmpTab.form = _.clone(this.defForm);
      this.rowData = [];
      this.selectId = "";
    },
    Acancel(){
      // form 초기화
      this.$refs.cmpTab.form = _.clone(this.defForm);
      this.rowData = [];
    },
    pwdChange(){
      const agentInfo = JSON.parse(JSON.stringify(this.$refs.cmpTab.form));
      let vm = this

      const grid = this.$refs.cmpTab.$refs.agentGrid;

      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "1"
      })

      if(chkDatas.length == 0){
        this.$swal({ type: 'warning', text: '비밀번호를 변경 할 사용자를 선택해주세요.' });
        return false;
      }

      if(chkDatas.length > 1){
        this.$swal({ type: 'warning', text: '비밀번호를 변경 할 유저는 한명만 체크해주세요.' });
        return false;
      }

      this.$modal.open({component: PwdChange, parent: this, width: 800,
          props: {before:'before',after:'after',userId:agentInfo.userId},
          events: {
            close(data) {
              console.log('close', data);
            },
        },
      });
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/asAgentMng/init`)
          .then(response => {
            this.combos['asAgentType'] = response.data.asAgentType;        //센터구분
            this.combos['areaAgent'] = response.data.areaAgent;            //지역구분
            this.combos['areaAgent2'] = response.data.areaAgent2;            //지역구분
            this.combos['contractStatus'] = response.data.contractStatus;  //계약상태
          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });
      this.createColumnDefs();
    },
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };

  },
  mounted() {
    //this.goOpen();
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  watch: {

  },
}
</script>